/*
 * Action.ts
 */
export class Action {
    constructor(type) {
        this.type = type;
    }
    static getAction(action) {
        return Action[action];
    }
    isPurchase() {
        return this == Action.PURCHASE;
    }
    isSpin() {
        return this == Action.SPIN;
    }
    isChooseCell() {
        return this == Action.CHOOSE_CELL;
    }
    isCollect() {
        return this == Action.COLLECT;
    }
    isStakeToSpin() {
        return this == Action.STAKE_TO_SPIN;
    }
    isStart() {
        return this == Action.START;
    }
    isPlayPrizeGame() {
        return this == Action.PLAY_PRIZE_GAME;
    }
    getType() {
        return this.type;
    }
}
//standard actions
Action.PURCHASE = new Action("PURCHASE");
Action.SPIN = new Action("SPIN");
Action.CHOOSE_CELL = new Action("CHOOSE_CELL");
Action.COLLECT = new Action("COLLECT");
Action.STAKE_TO_SPIN = new Action("STAKE_TO_SPIN");
//actions that exist on the server side, and *probably* aren't seen on front end
Action.START = new Action("START");
Action.PLAY_PRIZE_GAME = new Action("START");
//# sourceMappingURL=Action.js.map